import { ReportType } from '../report-table/types';
import { prepareTreeData, generateListKeys, prepareData, CUSTOM_GROUP_SET_KEY } from '../../../../../helpers/utils/reports';
import { injectUtmSectionsNode, IUtmSection } from '../../../../../helpers/utils/utmSections';
import cloneDeep from 'lodash/cloneDeep';

// Импорты констант группировок
import { groupingsData as groupingsDataUniversal, groupingsDataHome } from '../../../constants/reports';
import { groupingsData as groupingsDataOrder } from '../../../constants/reportsOrder';
import { groupingsData as groupingsDataPayment } from '../../../constants/reportsPayment';
import { groupingsData as groupingsDataAD, groupingsData2 as groupingsData2AD } from '../../../constants/reportsAD';
import { groupingsData as groupingsDataWebinar } from '../../../constants/reportsWebinar';
import { groupingsData as groupingsDataVisit } from '../../../constants/reportsVisits';

// Импорты констант метрик
import { metrics as metricsUniversal } from '../../../constants/reports';
import { metrics as metricsOrder } from '../../../constants/reportsOrder';
import { metrics as metricsPayment } from '../../../constants/reportsPayment';
import { metrics as metricsAD } from '../../../constants/reportsAD';
import { metrics as metricsWebinar } from '../../../constants/reportsWebinar';
import { metrics as metricsVisit } from '../../../constants/reportsVisits';

// Общие ads_keys для всех отчётов
export const ADS_KEYS = [
    'ads_date',
    'ads_date_w',
    'ads_date_dw',
    'ads_date_m',
    'ads_date_q',
    'ads_date_y',
    'ads_source',
    'ads_cabinet',
    'ads_campaign',
    'ads_adset',
    'ads_adv',
    'ads_campaign_id',
    'ads_adset_id',
    'ads_adv_id',
    'ads_utm_source',
    'ads_utm_medium',
    'ads_utm_campaign',
    'ads_utm_content',
    'ads_utm_term',
    'ads_utm_group',
    'ads_tag',
    // Срезы Яндекс.Директа (`ads_dim_*`) и «Параметры Яндекс.Директ» — тоже рекламные оси,
    // но их ключи динамические: см. `isAdGroupingKey` в ModalSettings
];

// Общие ads_metrics_keys для всех отчётов
export const ADS_METRICS_KEYS = [
    'ads_clicks_count',
    'ads_spend',
    'profit',
    'profit_per_reg',
    'profit_per_user',
    'romi',
    'roas',
    'drr',
    'payments_price',
    'buyers_price',
    'web_user_price',
    'orders_price',
    'orders_creators_price',
    'reg_price',
    'user_price',
    'ads_impressions',
    'cpm',
    'cpc',
    'ctr',
    'ads_click_to_reg_converse',
];

// Список метрик для которых не отображается накопительный график
export const DECLINE_CUMULATIVE_METRICS = [
    'web_30min_users_part',
    'web_30min_g_users_part',
    'web_180min_g_users_part',
    'web_240min_g_users_part',
    'payments_sum_avg',
    'creator_to_buyer_converse',
    'new_users_part',
    'paid_regs_part',
    'free_regs_part',
    'user_price',
    'web_user_to_no_app_converse',
    'user_to_no_step1_converse',
    'user_to_no_app_converse',
    'no_step1_to_no_step2_converse',
    'no_step2_to_no_step3_converse',
    'no_step3_to_no_step4_converse',
    'no_step4_to_no_step5_converse',
    'no_step5_to_no_app_converse',
    'orders_to_payments_converse',
    'orders_sum_avg',
    'orders_sum_avg_user',
    'user_to_creator_converse',
    'user_to_buyer_converse',
    'orders_to_forders_converse',
    'payments_sum_per_reg',
    'user_to_refunder_converse',
    'buyer_to_refunder_converse',
    'web_1min_users_part',
    'web_5min_users_part',
    'web_15min_users_part',
    'web_60min_users_part',
    'web_60min_g_users_part',
    'web_120min_g_users_part',
    'web_user_to_clicker_converse',
    'clicker_to_creator_converse',
    'user_to_web_user_converse',
    'web_user_to_creator_converse',
    'cpm',
    'cpc',
    'ctr',
    'ads_click_to_reg_converse',
    'profit_per_reg',
    'reg_price',
    'orders_price',
    'orders_creators_price',
    'forders_price',
    'buyers_price',
    'payments_price',
    'web_user_price',
    'profit_per_user',
    'romi',
    'roas',
    'drr',
];

// Алиасы для обратной совместимости (используются как ads_keys и ads_metrics_keys)
export const ads_keys = ADS_KEYS;
export const ads_metrics_keys = ADS_METRICS_KEYS;
export const declineCumulativeMetrics = DECLINE_CUMULATIVE_METRICS;

// Кэшированные listKeys для универсального отчёта (используются в tableSlice и других местах)
// Используем prepareTreeData для стабильных ключей на основе dataKey
export const listKeysGroupings = generateListKeys(prepareTreeData(cloneDeep(groupingsDataUniversal)));
export const listKeysMetrics = generateListKeys(prepareData(metricsUniversal, '', [], false));

// Кэшированные listKeys для Order отчёта (суффикс _2)
const orderGroupingsData = prepareTreeData(cloneDeep(groupingsDataOrder)).filter(
    (obj: { name?: string }) => obj?.name !== 'Реклама' && obj?.name !== 'Вебинары'
);
export const listKeysGroupingsOrder = generateListKeys(orderGroupingsData);
export const listKeysMetricsOrder = generateListKeys(prepareData(metricsOrder, '', [], false));

// Кэшированные listKeys для Payment отчёта (суффикс _3)
const paymentGroupingsData = prepareTreeData(cloneDeep(groupingsDataPayment)).filter(
    (obj: { name?: string }) => obj?.name !== 'Реклама' && obj?.name !== 'Вебинары'
);
export const listKeysGroupingsPayment = generateListKeys(paymentGroupingsData);
export const listKeysMetricsPayment = generateListKeys(prepareData(metricsPayment, '', [], false));

// Кэшированные listKeys для AD отчёта
export const listKeysGroupingsAD = generateListKeys(prepareTreeData(cloneDeep(groupingsDataAD)));
export const listKeysMetricsAD = generateListKeys(prepareData(metricsAD, '', [], false));

// Кэшированные listKeys для Webinar отчёта (суффикс _4)
export const listKeysGroupingsWebinar = generateListKeys(prepareTreeData(cloneDeep(groupingsDataWebinar)));
export const listKeysMetricsWebinar = generateListKeys(prepareData(metricsWebinar, '', [], false));

// Кэшированные listKeys для Visit отчёта (суффикс _6)
export const listKeysGroupingsVisit = generateListKeys(prepareTreeData(cloneDeep(groupingsDataVisit)));
export const listKeysMetricsVisit = generateListKeys(prepareData(metricsVisit, '', [], false));

// Кэшированные listKeys для Webinar Admin отчёта
import { groupingsAdminData as groupingsDataWebinarAdmin } from '../../../constants/reportsWebinar';
export const listKeysAdminGroupings = generateListKeys(prepareTreeData(cloneDeep(groupingsDataWebinarAdmin)));

// Функция для получения listKeys по типу отчёта
export const getListKeys = (reportType: ReportType) => {
    switch (reportType) {
        case 'universal':
            return { listKeysGroupings, listKeysMetrics };
        case 'order':
            return { listKeysGroupings: listKeysGroupingsOrder, listKeysMetrics: listKeysMetricsOrder };
        case 'payment':
            return { listKeysGroupings: listKeysGroupingsPayment, listKeysMetrics: listKeysMetricsPayment };
        case 'ad':
            return { listKeysGroupings: listKeysGroupingsAD, listKeysMetrics: listKeysMetricsAD };
        case 'webinar':
            return { listKeysGroupings: listKeysGroupingsWebinar, listKeysMetrics: listKeysMetricsWebinar };
        case 'visit':
            return { listKeysGroupings: listKeysGroupingsVisit, listKeysMetrics: listKeysMetricsVisit };
        default:
            return { listKeysGroupings, listKeysMetrics };
    }
};

export interface GroupingsConfig {
    getData: (customGroups?: any[], utmSections?: IUtmSection[]) => any[];
    getListKeys: (customGroups?: any[], utmSections?: IUtmSection[]) => any[];
    hasAdsGroups: boolean;
    filterAds?: boolean;
    filterWebinars?: boolean;
}

// Имена узлов для встраивания динамических «Групп регистраций» в дерево группировок
const REGISTRATION_ENTITY_NAME = 'Регистрации';
export const REGISTRATION_GROUPS_NODE_NAME = 'Группы регистраций';
// Подпункт со списком отдельных групп (работают как обычные группировки, без свёртки)
export const REGISTRATION_GROUPS_SELECT_NODE_NAME = 'Выбор групп регистраций';

/**
 * Встраивает узел «Группы регистраций» внутрь сущности «Регистрации».
 * Узел добавляется ВСЕГДА (даже при пустом списке) — чтобы у него была видна иконка «+».
 * customGroups имеет форму [{ name: 'Группы регистраций', children: [<листья-группы>] }].
 *
 * Внутри узла — ДВА пункта:
 *  1. «Группы регистраций» (лист-переключатель, dataKey = custom_group_set) — при выборе
 *     берёт ВСЕ доступные группы и СХЛОПЫВАЕТ их в один уровень отчёта. Список входящих
 *     групп несём в memberKeys, чтобы запрос знал состав набора.
 *  2. «Выбор групп регистраций» (контейнер) — раскрывается в список групп; выбор отдельной
 *     группы работает как ОБЫЧНАЯ группировка (свой уровень, без свёртки).
 */
export const injectRegistrationGroupsNode = (data: any[], customGroups?: any[]): any[] => {
    const groupsChildren = customGroups?.[0]?.children ?? [];
    // Ключи всех доступных групп — состав свёрнутого набора для переключателя.
    const memberKeys = groupsChildren
        .map((child: any) => child?.dataKey)
        .filter(Boolean);
    const regEntity = data.find((item) => item?.name === REGISTRATION_ENTITY_NAME);
    if (regEntity && Array.isArray(regEntity.children)) {
        regEntity.children = regEntity.children.filter(
            (child: any) => child?.name !== REGISTRATION_GROUPS_NODE_NAME
        );
        const groupsNode = {
            name: REGISTRATION_GROUPS_NODE_NAME,
            isGroupsNode: true,
            description: 'Группы регистраций: вы создаёте группы и описываете фильтром, что в них входит. Каждая группа — строка отчёта.',
            children: [
                // Пункт 1 — переключатель «все группы одним свёрнутым уровнем»
                {
                    name: REGISTRATION_GROUPS_NODE_NAME,
                    dataKey: CUSTOM_GROUP_SET_KEY,
                    isGroupSetToggle: true,
                    memberKeys,
                    description: 'Все группы регистраций одним свёрнутым уровнем отчёта.',
                },
                // Пункт 2 — список отдельных групп (обычные группировки, без свёртки)
                {
                    name: REGISTRATION_GROUPS_SELECT_NODE_NAME,
                    isGroupsSelectNode: true,
                    description: 'Группы регистраций как отдельные уровни отчёта (без свёртки).',
                    children: cloneDeep(groupsChildren),
                },
            ],
        };
        // Вставляем сразу после подгруппы UTM-меток регистрации; если её нет — в конец.
        // Имя подгруппы различается по отчётам: universal — «UTM регистрации»,
        // реклама — «UTM-метка регистрации», заказы — «UTM-метки регистрации».
        const UTM_REG_NODE_NAMES = [ 'UTM регистрации', 'UTM-метка регистрации', 'UTM-метки регистрации' ];
        const utmIndex = regEntity.children.findIndex((child: any) => UTM_REG_NODE_NAMES.includes(child?.name));
        if (utmIndex >= 0) {
            regEntity.children.splice(utmIndex + 1, 0, groupsNode);
        } else {
            regEntity.children.push(groupsNode);
        }
    }
    return data;
};

export interface MetricsConfig {
    getData: (createdMetrics?: any[], checkPermission?: (roles: string[]) => boolean) => any[];
    getListKeys: (data: any[]) => any[];
    hasAdsMetrics: boolean;
}

// Конфигурация группировок для каждого типа отчёта
export const getGroupingsConfig = (reportType: ReportType): GroupingsConfig => {
    switch (reportType) {
        case 'universal':
            return {
                getData: (customGroups) =>
                    prepareTreeData(
                        injectRegistrationGroupsNode(cloneDeep(groupingsDataUniversal), customGroups)
                    ),
                getListKeys: (customGroups) =>
                    generateListKeys(
                        prepareTreeData(
                            injectRegistrationGroupsNode(cloneDeep(groupingsDataUniversal), customGroups)
                        )
                    ),
                hasAdsGroups: true,
            };
        case 'order':
            // Заказы используют reg-поля в неймспейсе регистраций (суффикс _2),
            // узел «Группы регистраций» встраивается так же, как в universal/ad.
            return {
                getData: (customGroups) => {
                    const data = prepareTreeData(
                        injectRegistrationGroupsNode(cloneDeep(groupingsDataOrder), customGroups)
                    );
                    return data.filter((obj: { name?: string }) =>
                        obj?.name !== 'Реклама' && obj?.name !== 'Вебинары'
                    );
                },
                getListKeys: (customGroups) => {
                    const data = prepareTreeData(
                        injectRegistrationGroupsNode(cloneDeep(groupingsDataOrder), customGroups)
                    ).filter((obj: { name?: string }) =>
                        obj?.name !== 'Реклама' && obj?.name !== 'Вебинары'
                    );
                    return generateListKeys(data);
                },
                hasAdsGroups: false,
                filterAds: true,
                filterWebinars: true,
            };
        case 'payment':
            // Платежи используют reg-поля в неймспейсе регистраций (суффикс _3),
            // узел «Группы регистраций» встраивается так же, как в universal/ad/order.
            return {
                getData: (customGroups) => {
                    const data = prepareTreeData(
                        injectRegistrationGroupsNode(cloneDeep(groupingsDataPayment), customGroups)
                    );
                    return data.filter((obj: { name?: string }) =>
                        obj?.name !== 'Реклама' && obj?.name !== 'Вебинары'
                    );
                },
                getListKeys: (customGroups) => {
                    const data = prepareTreeData(
                        injectRegistrationGroupsNode(cloneDeep(groupingsDataPayment), customGroups)
                    ).filter((obj: { name?: string }) =>
                        obj?.name !== 'Реклама' && obj?.name !== 'Вебинары'
                    );
                    return generateListKeys(data);
                },
                hasAdsGroups: false,
                filterAds: true,
                filterWebinars: true,
            };
        case 'ad':
            // Реклама использует reg-поля в неймспейсе регистраций (без суффикса, как universal),
            // поэтому узел «Группы регистраций» встраивается так же, как в universal.
            // «Параметры Яндекс.Директ» (секции из GET /utm-params/sections: срезы Директа `ads_dim_*`
            // и параметры меток) — ТОЛЬКО здесь: узел встаёт в сущность «Реклама» сразу после «Даты рекламы».
            return {
                getData: (customGroups, utmSections) =>
                    prepareTreeData(
                        injectUtmSectionsNode(
                            injectRegistrationGroupsNode(cloneDeep(groupingsDataAD), customGroups),
                            utmSections
                        )
                    ),
                getListKeys: (customGroups, utmSections) =>
                    generateListKeys(
                        prepareTreeData(
                            injectUtmSectionsNode(
                                injectRegistrationGroupsNode(cloneDeep(groupingsDataAD), customGroups),
                                utmSections
                            )
                        )
                    ),
                hasAdsGroups: false,
            };
        case 'webinar':
            // Вебинары используют reg-поля в неймспейсе регистраций (суффикс _4),
            // узел «Группы регистраций» встраивается так же, как в universal/ad/order/payment.
            // Ветка superadmin (groupingsAdminData) инъектится отдельно в ReportGroupings.
            return {
                getData: (customGroups) => {
                    const data = prepareTreeData(
                        injectRegistrationGroupsNode(cloneDeep(groupingsDataWebinar), customGroups)
                    );
                    return data.filter((obj: { name?: string }) =>
                        obj?.name !== 'Реклама'
                    );
                },
                getListKeys: (customGroups) => {
                    const data = prepareTreeData(
                        injectRegistrationGroupsNode(cloneDeep(groupingsDataWebinar), customGroups)
                    ).filter((obj: { name?: string }) =>
                        obj?.name !== 'Реклама'
                    );
                    return generateListKeys(data);
                },
                hasAdsGroups: false,
                filterAds: true,
            };
        case 'visit':
            return {
                getData: () => prepareTreeData(cloneDeep(groupingsDataVisit)),
                getListKeys: () => generateListKeys(prepareTreeData(cloneDeep(groupingsDataVisit))),
                hasAdsGroups: false,
            };
        default:
            return {
                getData: (customGroups) =>
                    prepareTreeData(
                        injectRegistrationGroupsNode(cloneDeep(groupingsDataUniversal), customGroups)
                    ),
                getListKeys: (customGroups) =>
                    generateListKeys(
                        prepareTreeData(
                            injectRegistrationGroupsNode(cloneDeep(groupingsDataUniversal), customGroups)
                        )
                    ),
                hasAdsGroups: true,
            };
    }
};

// Конфигурация метрик для каждого типа отчёта
export const getMetricsConfig = (reportType: ReportType): MetricsConfig => {
    switch (reportType) {
        case 'universal':
            return {
                getData: (createdMetrics, checkPermission) => {
                    const baseData = prepareData(
                        [...cloneDeep(metricsUniversal), ...(createdMetrics?.[0]?.children?.length > 0 ? cloneDeep(createdMetrics) : [])],
                        '',
                        [],
                        false
                    );
                    if (checkPermission) {
                        return baseData.filter((el: any) =>
                            checkPermission(['superadmin']) ? true : el.name !== 'Посещения'
                        );
                    }
                    return baseData;
                },
                getListKeys: (data) => generateListKeys(data),
                hasAdsMetrics: true,
            };
        case 'order':
            return {
                getData: (createdMetrics, checkPermission) => {
                    const baseData = prepareData(
                        [...cloneDeep(metricsOrder), ...(createdMetrics?.[0]?.children?.length > 0 ? cloneDeep(createdMetrics) : [])],
                        '',
                        [],
                        false
                    );
                    if (checkPermission) {
                        return baseData.filter((el: any) =>
                            checkPermission(['superadmin']) ? true : el.name !== 'Посещения'
                        );
                    }
                    return baseData;
                },
                getListKeys: (data) => generateListKeys(data),
                hasAdsMetrics: false,
            };
        case 'payment':
            return {
                getData: (createdMetrics, checkPermission) => {
                    const baseData = prepareData(
                        [...cloneDeep(metricsPayment), ...(createdMetrics?.[0]?.children?.length > 0 ? cloneDeep(createdMetrics) : [])],
                        '',
                        [],
                        false
                    );
                    if (checkPermission) {
                        return baseData.filter((el: any) =>
                            checkPermission(['superadmin']) ? true : el.name !== 'Посещения'
                        );
                    }
                    return baseData;
                },
                getListKeys: (data) => generateListKeys(data),
                hasAdsMetrics: false,
            };
        case 'ad':
            return {
                getData: (createdMetrics, checkPermission) => {
                    const baseData = prepareData(
                        [...cloneDeep(metricsAD), ...(createdMetrics?.[0]?.children?.length > 0 ? cloneDeep(createdMetrics) : [])],
                        '',
                        [],
                        false
                    );
                    if (checkPermission) {
                        return baseData.filter((el: any) =>
                            checkPermission(['superadmin']) ? true : el.name !== 'Посещения'
                        );
                    }
                    return baseData;
                },
                getListKeys: (data) => generateListKeys(data),
                hasAdsMetrics: true,
            };
        case 'webinar':
            return {
                getData: (createdMetrics, checkPermission) => {
                    const baseData = prepareData(
                        [...cloneDeep(metricsWebinar), ...(createdMetrics?.[0]?.children?.length > 0 ? cloneDeep(createdMetrics) : [])],
                        '',
                        [],
                        false
                    );
                    if (checkPermission) {
                        return baseData.filter((el: any) =>
                            checkPermission(['superadmin']) ? true : el.name !== 'Посещения'
                        );
                    }
                    return baseData;
                },
                getListKeys: (data) => generateListKeys(data),
                hasAdsMetrics: false,
            };
        case 'visit':
            return {
                getData: (createdMetrics, checkPermission) => {
                    const baseData = prepareData(
                        [...cloneDeep(metricsVisit), ...(createdMetrics?.[0]?.children?.length > 0 ? cloneDeep(createdMetrics) : [])],
                        '',
                        [],
                        false
                    );
                    if (checkPermission) {
                        return baseData.filter((el: any) =>
                            checkPermission(['superadmin']) ? true : el.name !== 'Посещения'
                        );
                    }
                    return baseData;
                },
                getListKeys: (data) => generateListKeys(data),
                hasAdsMetrics: false,
            };
        default:
            return {
                getData: () => prepareData(metricsUniversal, '', [], false),
                getListKeys: (data) => generateListKeys(data),
                hasAdsMetrics: true,
            };
    }
};
